import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const PressRelease = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M8.64201 16.439L9.0633 11.5415C9.07666 11.3861 9.25471 11.3051 9.38058 11.3971L22.5937 21.0539C22.9276 21.2979 22.8378 21.8187 22.4415 21.9368L17.8814 23.2959C17.582 23.3851 17.2581 23.3293 17.0059 23.145L9.04846 17.3322C8.76616 17.1259 8.61205 16.7873 8.64201 16.439Z"
          fill="#9A5BFF"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M10.8217 9.66714L16.7038 9.04194C17.183 8.99101 17.6644 9.1148 18.0596 9.39055L22.3181 12.3619C22.7782 12.683 23.0824 13.1826 23.1562 13.7388L23.9344 19.5989C24.1679 21.3568 22.1678 22.5264 20.7502 21.461L9.83146 13.2547C8.37995 12.1638 9.01609 9.85906 10.8217 9.66714Z"
          fill="#7A31F0"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M27.653 10.7823C27.1539 14.5045 23.7319 17.1174 20.0097 16.6184C16.2875 16.1193 13.6746 12.6973 14.1736 8.97507C14.6727 5.25284 18.0947 2.63993 21.8169 3.13898C25.5391 3.63803 28.152 7.06005 27.653 10.7823Z"
          fill="#F655DD"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M15.9688 5.21875C16.1719 8.35937 21.6563 13.875 26.6563 13.5469"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeDasharray="0.01 2.3"
        />
        <path
          d="M18.5013 3.50011C17.657 7.18754 23.8735 11.9061 27.6563 10.8125"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeDasharray="0.01 2.3"
        />
        <path
          d="M20.9997 3.09367C20.4059 5.99996 25.5 8.75 27.5619 8.28116"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeDasharray="0.01 2.3"
        />
        <path
          d="M14.4531 7.76562C15.3594 10.2344 17.8906 14.1875 24.1875 15.8281"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeDasharray="0.01 2.3"
        />
        <path
          d="M9.06239 23.1122L11.0616 19.3235C11.1694 19.1193 11.4345 19.0602 11.6189 19.1993L14.4387 21.327C14.6572 21.4919 14.657 21.8202 14.4382 21.9848L10.8804 24.6613C10.4363 24.9955 9.82272 24.9883 9.38646 24.6439C8.92326 24.2783 8.78697 23.6342 9.06239 23.1122Z"
          fill="#FF4BE3"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <path
          d="M9.35938 24.625C6.92188 27 9.48439 29.761 11.6719 27.261C13.8594 24.761 16.6094 27.511 13.9219 29.636"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    )
  },
)

export default PressRelease
